import React from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { AlertTriangle } from 'lucide-react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught by boundary:', error, errorInfo);
    this.setState({
      error,
      errorInfo
    });
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
    window.location.href = '/dashboard';
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center p-4" style={{ background: 'var(--bg-primary)' }}>
          <Card className="max-w-md w-full" style={{ background: 'var(--bg-card)', border: '2px solid #ef4444' }}>
            <CardContent className="p-8 text-center">
              <AlertTriangle className="w-16 h-16 mx-auto mb-4 text-red-500" />
              <h2 className="text-2xl font-bold mb-3" style={{ color: 'var(--text-primary)' }}>
                Something went wrong
              </h2>
              <p className="text-base mb-6" style={{ color: 'var(--text-secondary)' }}>
                We're sorry, but something unexpected happened. Don't worry, your data is safe.
              </p>
              {process.env.NODE_ENV === 'development' && this.state.error && (
                <details className="mb-6 text-left">
                  <summary className="cursor-pointer text-sm font-semibold mb-2" style={{ color: 'var(--text-secondary)' }}>
                    Error Details (Development Only)
                  </summary>
                  <pre className="text-xs overflow-auto p-4 rounded" style={{ background: 'rgba(239, 68, 68, 0.1)', color: 'var(--text-primary)' }}>
                    {this.state.error.toString()}
                    {this.state.errorInfo && this.state.errorInfo.componentStack}
                  </pre>
                </details>
              )}
              <Button
                onClick={this.handleReset}
                style={{ 
                  background: 'linear-gradient(135deg, var(--primary-blue) 0%, var(--primary-green) 100%)',
                  color: 'white'
                }}
              >
                Return to Dashboard
              </Button>
            </CardContent>
          </Card>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
